import React, { FC } from 'react'
import * as Styles from './exclusiveToggleGroup.module.scss'

export type ExclusiveToggleGroupProps = {
  className?: string
  title?: string
  items: {
    label: string
    value: string
  }[]
  value?: string
  onChange: (value: string | undefined) => void
}

export const ExclusiveToggleGroup: FC<ExclusiveToggleGroupProps> = ({
  className = '',
  title,
  items = [],
  value,
  onChange,
}) => {
  return (
    <div className={`${Styles.exclusiveToggleGroup} ${className}`}>
      {title && <h3 className={Styles.title}>{title}</h3>}
      <ul className={Styles.toggleList}>
        {items?.map(item => {
          const isActive = item.value === value

          return (
            <li key={item.value} className={Styles.toggleListItem}>
              <button
                type="button"
                className={`${Styles.toggleListItemButton} ${
                  isActive ? Styles.active : ''
                }`}
                onClick={() => {
                  onChange(isActive ? undefined : item.value)
                }}
              >
                {item.label}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
